import React, { useEffect, useState } from 'react'
import { CaretDownOutlined, CloseCircleOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Tag } from 'antd'
import './RelativeCollapse.scss'
import { IPhone } from '../../api/relatives/relativesApi'
import { getListRelatives, getListTypePhone, ISelectOption } from '../../api/selectOptions/selectOptionsApi'
import { fommatSelectOption, getTitleSelectOption } from '../../until'
import { IRelationshipADD_V2 } from '../../pages/Customers/Modal/AddRelativeAddCustomer'
import { dataGender } from '../../services/data'

interface Props {
  index: number
  infoRelative: IRelationshipADD_V2

  show?: boolean
  showControl?: boolean
  className?: string

  handleOpenModalUpdate?: (index: number) => void
  handleOpenModalDele?: (index: number) => void
  onToggle?: () => void
  onDelete?: () => void
  onEdit?: () => void
}

const RelativeCollapseAddCustomer: React.FC<Props> = (props) => {
  const {
    index, infoRelative,
    show = false, showControl = false, className = '',
    onToggle, onDelete, onEdit, handleOpenModalUpdate, handleOpenModalDele
  } = props
  const { inforSelectedCodeCustomer, userName, email, phone, CCCD, gender, profession, relativeId } = infoRelative
  const [isShow, setIsShow] = useState(show)

  const [sLTypePhone, setSLTypePhone] = useState<ISelectOption[]>([])
  const [sLRelative, setSLRelative] = useState<ISelectOption[]>([])


  const gSLTypePhone = async () => {
    const result = await getListTypePhone();
    if (result?.status) {
      setSLTypePhone(fommatSelectOption(result.data))
    } else {
    }
  }

  const gSListRelatives = async () => {
    const result = await getListRelatives();
    if (result?.status) {
      setSLRelative(fommatSelectOption(result.data))
    }
  }

  useEffect(() => {
    setIsShow(show)
  }, [show])

  const toggleShow = () => {
    // setIsShow(!isShow)

    if (onToggle) {
      onToggle()
    }
  }

  useEffect(() => {
    if (show && !sLTypePhone.length)
      gSLTypePhone()
    if (!sLRelative.length)
      gSListRelatives()

  }, [show])
  return (
    <div className={`relative-collapse ${className} ${showControl ? 'relative-collapse-with-control' : ''}`}>
      <div
        className={`relative-collapse__title ${isShow ? 'show' : 'collapsed'}`}
      >
        <div
          className="icon"
          onClick={toggleShow}
        >
          <CaretDownOutlined />
        </div>
        <div
          className="title"
          onClick={toggleShow}
        >
          <span className='font-bold neutral-gray-700'>{userName}</span>
          <Tag
            className='rs-tag sunset-orange no-border'
          >{relativeId ? getTitleSelectOption(sLRelative, relativeId) : ""}</Tag>
        </div>
        {
          showControl && (
            <div className="control">
              <Button
                icon={<CloseCircleOutlined />}
                className="rs-button delete"
                onClick={() => handleOpenModalDele?.(Number(index))}
              />
              <Button
                icon={<EditOutlined />}
                className="rs-button"
                onClick={() => handleOpenModalUpdate?.(Number(index))}
              />
            </div>
          )
        }
      </div>

      <div
        className={`relative-collapse__content ${isShow ? 'show' : 'collapsed'}`}
      >
        <div className="item">
          <div className="item__label">Mã định danh khách hàng</div>
          <div className="item__value">{inforSelectedCodeCustomer?.value }</div>
        </div>
        <div className="item">
          <div className="item__label">Họ và tên</div>
          <div className="item__value">{userName}</div>
        </div>
        <div className="item">
          <div className="item__label">Giới tính</div>
          <div className="item__value">{(gender !== undefined && gender !== null) ? dataGender[gender].title : ""}</div>
        </div>
        <div className="item">
          <div className="item__label">CCCD</div>
          <div className="item__value">{CCCD ? CCCD[0]?.name : ''}</div>
        </div>
        <div className="item">
          <div className="item__label">Số điện thoại</div>
          <div className="item__value">
            <div className="custom-page-css flex flex-col items-end gap-1">
              {phone?.map((item, i) => (
                <span className='neutral-gray-400' key={i}>
                  {item.phone}
                  <span className="sunset-orange-6">( {getTitleSelectOption(sLTypePhone, item.categoryPhoneId)} )</span>
                </span>
              ))}
            </div>

          </div>
        </div>
        <div className="item">
          <div className="item__label">Email</div>
          <div className="item__value">{email?.join(', ')}</div>
        </div>
      </div>
    </div>
  )
}

export default RelativeCollapseAddCustomer
